const viteEnv = import.meta.env ?? {};

export const IS_VITE = viteEnv.VITE_SETUP !== undefined;
export const IS_SERVER = typeof window === 'undefined';
export const NEXT_PUBLIC_HOST_NAME = IS_VITE ? viteEnv.NEXT_PUBLIC_HOST_NAME : process.env.NEXT_PUBLIC_HOST_NAME;
export const NEXT_PUBLIC_COOKIE_DOMAIN = IS_VITE
    ? viteEnv.NEXT_PUBLIC_COOKIE_DOMAIN
    : process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
export const NEXT_PUBLIC_CHECK24_DOMAIN = IS_VITE
    ? viteEnv.NEXT_PUBLIC_CHECK24_DOMAIN
    : process.env.NEXT_PUBLIC_CHECK24_DOMAIN;

export const IS_DEV = !!NEXT_PUBLIC_HOST_NAME?.includes('-local.check24-test.de');
export const IS_STAGING = !!NEXT_PUBLIC_HOST_NAME?.includes('individualreisen.check24-test.de');
export const IS_TBS = !!NEXT_PUBLIC_HOST_NAME?.includes('frontend-tbs');
export const IS_PROD = !!NEXT_PUBLIC_HOST_NAME?.includes('individualreisen.check24.de');

export const NEXT_PUBLIC_CDN_URL = IS_VITE ? viteEnv.NEXT_PUBLIC_CDN_URL : process.env.NEXT_PUBLIC_CDN_URL;

// SSO
export const NEXT_PUBLIC_SSO_PRODUCT_ID = IS_VITE
    ? viteEnv.NEXT_PUBLIC_SSO_PRODUCT_ID
    : process.env.NEXT_PUBLIC_SSO_PRODUCT_ID;

// Google
export const NEXT_PUBLIC_GOOGLE_MAPS_KEY = IS_VITE
    ? viteEnv.NEXT_PUBLIC_GOOGLE_MAPS_KEY
    : process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

// Tracking
export const NEXT_PUBLIC_GENERAL_TRACKING_PRODUCT_NAME = IS_VITE
    ? viteEnv.NEXT_PUBLIC_GENERAL_TRACKING_PRODUCT_NAME
    : process.env.NEXT_PUBLIC_GENERAL_TRACKING_PRODUCT_NAME;
